(function () {
  'use strict';

  // Component used for booking item and booking item service item

  angular.module('app').component('bookingItemNotificationInfo', bookingItemNotificationInfo());

  function bookingItemNotificationInfo() {
    return {
      bindings: {
        notification: '<',
        bookingItem: '<',
        bookingItemServiceItem: '<',
        bookingCurrency: '<',
      },
      controller: BookingItemNotificationInfoComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/bookings/booking-items/booking-item-notification/' +
        'notification-info/booking-item-notification-info.component.html',
    };
  }

  BookingItemNotificationInfoComponent.$inject = ['CONFIGURATIONS'];

  function BookingItemNotificationInfoComponent(config) {
    let vm = this;

    vm.dateDisplay = config.DATE_DISPLAY;

    vm.$onInit = function () {
      vm.bookingItemData = !vm.bookingItemServiceItem ? vm.bookingItem : vm.bookingItemServiceItem;
    };

    // if (!vm.bookingItemServiceItem){
    // } else{
    //     vm.bookingItemData = vm.bookingItemServiceItem;
    // }
  }
})();
